import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'admin-vaccine',
  templateUrl: 'admin-vaccine.component.html'
})
export class AdminVaccineComponent {
  constructor() {}
}



// WEBPACK FOOTER //
// D:/TMB/TMB/MYTMB.UI/src/app/pages/admin-vaccine/admin-vaccine.component.ts